export default RAILS_ASSET_URL("/gallery-image-09.webp")
